import api from 'api';

export const ASSET_TRANSFER_STATS_ASYNC_ACTION_START = 'ASSET_TRANSFER_STATS_ASYNC_ACTION_START';
export const ASSET_TRANSFER_STATS_ASYNC_ACTION_ERROR = 'ASSET_TRANSFER_STATS_ASYNC_ACTION_ERROR';
export const ASSET_TRANSFER_STATS_ASYNC_UPDATE_SUCCESS = 'ASSET_TRANSFER_STATS_ASYNC_UPDATE_SUCCESS';
export const ASSET_TRANSFER_STATS_UPDATE_SUCCESS = 'ASSET_TRANSFER_STATS_UPDATE_SUCCESS';
export const ASSET_TRANSFER_STATS_RESET_STATE = 'ASSET_TRANSFER_STATS_RESET_STATE';

function assetTransferStatsAsyncStart() {
  return {
    type: ASSET_TRANSFER_STATS_ASYNC_ACTION_START,
  };
}

function assetTransferStatsAsyncUpdateSuccess(data) {
  return {
    type: ASSET_TRANSFER_STATS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function assetTransferStatsAsyncError(error) {
  return {
    type: ASSET_TRANSFER_STATS_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetAssetTransferStatsState() {
  return {
    type: ASSET_TRANSFER_STATS_RESET_STATE,
  };
}

export function updateAssetTransferStats(data) {
  return {
    type: ASSET_TRANSFER_STATS_UPDATE_SUCCESS,
    data,
  };
}


export function getAssetTransferStatsAsync(id) {
  return (dispatch, getState) => {
    dispatch(assetTransferStatsAsyncStart());
    return api.request(`assets/stats?assetTransferId=${id}`, 'get')
    .then((data) => {
      dispatch(assetTransferStatsAsyncUpdateSuccess(data));
    })
    .catch((err) => {
      dispatch(assetTransferStatsAsyncError('Unable to get asset transfers stats'));
      throw (err);
    });
  };
}